/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResolveCostSavingsRecommendationsRequest {
    getFixupPrototypeFunction() { return ResolveCostSavingsRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ResolveCostSavingsRecommendationsRequest>): ResolveCostSavingsRecommendationsRequest {
        let obj = Object.assign(new ResolveCostSavingsRecommendationsRequest(), model);
        ResolveCostSavingsRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResolveCostSavingsRecommendationsRequest>): ResolveCostSavingsRecommendationsRequest {
        if (!model) return null;
        return ResolveCostSavingsRecommendationsRequest.newInstance(<ResolveCostSavingsRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResolveCostSavingsRecommendationsRequest) {
        if (!obj) return;

        models.ResolveCostSavingsRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResolveCostSavingsRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ResolveCostSavingsRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action to be applied to resolve the recommendation
     */
    action_name: models.ResolveCostSavingsRecommendationsAction;

    /**
     * Resource Id to which the recommendation should be applied. Can be fetched from 'CostSavingViewRecommendation' api.
     */
    resources: Array<string>;

}
